<template>
  <div class="burger-item">
    <span class="burger-item__title">{{ item.name }}</span>
    <component
      :is="component"
      :links="item.items"
      @click-menu-item="$emit('click-menu-item', $event)"
    />
  </div>
</template>

<script lang="ts">
  import type { Component, PropType } from 'vue';
  import BurgerLinksList from '~/components/TheHeader/Burger/BurgerLinksList.vue';
  import BurgerSocialsList from '~/components/TheHeader/Burger/BurgerSocialsList.vue';
  import type { IMenu } from '~/types/store/menus';
  import { MENUS_TECH_NAMES } from '~/constants';

  export default defineNuxtComponent({
    name: 'BurgerItem',
    components: {
      BurgerLinksList,
      BurgerSocialsList,
    },

    props: {
      item: {
        type: Object as PropType<IMenu>,
        required: true,
      },
    },

    emits: ['click-menu-item'],

    computed: {
      component(): Component {
        const { burgerSocials } = MENUS_TECH_NAMES;
        return this.item.domain === burgerSocials ? BurgerSocialsList : BurgerLinksList;
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '../styles/TheHeader.variables.scss' as *;

  .burger-item {
    &__title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 56px;

      padding: 0 $spacing-12;
      @include normalText;
      font-weight: 500;

      @include big-tablet {
        height: 52px;
        padding: $spacing-3 $spacing-6;
        font-size: 18px;
      }
    }
  }
</style>
